export const BTC_TO_USDT_RATE = '2400'